import { render, staticRenderFns } from "./CommercialTermsPage.vue?vue&type=template&id=27650f3d"
import script from "./CommercialTermsPage.vue?vue&type=script&lang=js"
export * from "./CommercialTermsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports